<template>
  <div>
    <Scan :code="code" @subCode="getChildCode"></Scan>
    <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o">
      【退货批次：{{ data.cReturnGoodsBatchNo }}】数量：{{ codeNum }}
    </van-notice-bar>
    <div class="scanList" v-for="(item, index) in list" :key="index">
      <div class="listTop">
        <div class="">产品码：{{ item.fCode }}</div>
        <img src="../../assets/close.png" @click="deleteCode(index)" />
      </div>
      <div class="listBottom">
        <div class="listBottomLine">
          <p>产品类型：</p>
          <p>{{ item.codeTypeName }}</p>
        </div>
        <div class="listBottomLine">
          <p>采集日期：</p>
          <p>{{ item.time }}</p>
        </div>
        <div class="listBottomLine">
          <p>产品名称：</p>
          <p>{{ item.cProductName }}</p>
        </div>
        <div class="listBottomLine">
          <p>产品规格：</p>
          <p>{{ item.cStandard }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import {
  Button,
  List,
  Cell,
  Toast,
  Empty,
  Step,
  Steps,
  NoticeBar,
  Dialog,
} from "vant";
import Scan from "../../components/Scan";

export default {
  data() {
    return {
      titName: "退货采集",
      list: new Array(),
      loading: false,
      finished: false,
      num: 1,
      code: "",
      active: 0,
      fDealerReturnGoodsHeaderId: 0,
      fType: 1, //1-大码，2-小码
      codeNum: 0,
    };
  },
  props: ["data"],
  components: {
    [Button.name]: Button,
    [List.name]: List,
    [Cell.name]: Cell,
    [Toast.name]: Toast,
    [Empty.name]: Empty,
    [Step.name]: Step,
    [Steps.name]: Steps,
    [NoticeBar.name]: NoticeBar,
    [Dialog.name]: Dialog,
    Scan: Scan,
  },
  methods: {
    getChildCode(params) {
      //得到码
      this.code = params;
      if (this.code.length === 10) {
        this.fType = 1;
      } else {
        this.fType = 2;
      }
      this.ScanCode();
    },
    ScanCode() {
      var dd = {
        ticket: sessionStorage.getItem("ticket"),
        fDealerReturnGoodsHeaderId: this.fDealerReturnGoodsHeaderId,
        cReturnGoodsBatchNo: this.data.cReturnGoodsBatchNo,
        fType: this.fType,
        fCode: this.code,
        cRemark: this.data.cRemark,
        cAddress: "",
        cPic: "",
      };
      this.$post("/api/PhoneAPI/DealerReturnGoodsIn", dd)
        .then((res) => {
          if (res.IsSucceed) {
            var listDD = res.Content;
            listDD.fCode = this.code;
            if (this.code.length === 10) {
              listDD.codeTypeName = "大码";
            } else {
              listDD.codeTypeName = "小码";
            }
            var aData = new Date();
            listDD.time =
              aData.getFullYear() +
              "-" +
              (aData.getMonth() + 1) +
              "-" +
              aData.getDate();
            this.list.unshift(listDD);
            this.fDealerReturnGoodsHeaderId =
              res.Content.DealerReturnGoodsHeaderId;
            this.$emit("subListData", this.list);
            this.setNum();
            Toast(res.Message);
            this.code = "";
          } else {
            this.code = "";
            Toast(res.Message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteCode(_index) {
      var _this = this;
      Dialog.confirm({
        message: "确认要删除吗",
      })
        .then(() => {
          // on confirm
          var list = this.list[_index];
          var fCodeType = 0;
          if (list.fCode.length === 10) {
            fCodeType = 1;
          }

          var dd = {
            ticket: sessionStorage.getItem("ticket"),
            fCode: list.fCode,
            fIsBigCode: fCodeType,
            fDealerReturnGoodsHeaderId: list.DealerReturnGoodsHeaderId,
            fDealerReturnGoodsBodyId: list.DealerReturnGoodsBodyId,
          };
          _this
            .$get("/api/PhoneAPI/DealerReturnGoodsInRollBack", dd)
            .then((res) => {
              if (res.IsSucceed) {
                this.list.splice(_index, 1);
                this.$emit("subListData", this.list);
                this.setNum();
                Toast(res.Message);
              } else {
                Toast(res.Message);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    setNum() {
      if (this.list.length == 0) {
        this.codeNum = 0;
      }
      else{
        var cNum=0;
        for (let index = 0; index < this.list.length; index++) {
          cNum=parseInt(cNum)+parseInt(this.list[index].fCodeCount);
        }
        this.codeNum = cNum;
      }
    },
  },
};
</script>
<style scoped>
.scanList {
  margin: 10px;
  border: 1px solid #eee;
  border-radius: 5px;
  font-size: 14px;
  padding: 8px;
}
.listTop {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 0 10px 0;
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;
}
.listTop img {
  width: 20px;
  height: 20px;
}
.listBottomLine {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0;
}
.listBottomLine div:last-child {
  width: 100px;
  flex-shrink: 0;
  margin-right: 10px;
}
.listBottomLine div:last-child {
  color: #666666;
}
</style>
